var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row notice"},[_c('div',{staticClass:"column"},[_c('img',{attrs:{"src":require("../../assets/discount.png")}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-531ec560","hasScoped":true,"buble":{"transforms":{}}}!./src/components/notice/template.html
// module id = 864
// module chunks = 0